import { apiUrl, deleteArray, get, postArray } from './apiUtils';

const baseUrl = apiUrl + '/permissions/';

export function getAllPermissions(): Promise<unknown> {
  return get(baseUrl);
}

export function getPermissionGroup(
  userProfileGroupId: string
): Promise<unknown> {
  return get(`${baseUrl}group/${userProfileGroupId}`);
}

export function addPermissionGroup(
  permissionKeys: string[],
  userProfileGroupId: string
): Promise<unknown> {
  return postArray(`${baseUrl}group/${userProfileGroupId}`, permissionKeys);
}

export function deletePermissionGroup(
  permissionKeys: string[],
  userProfileGroupId: string
): Promise<unknown> {
  return deleteArray(`${baseUrl}group/${userProfileGroupId}`, permissionKeys);
}

export function getPermissionUser(userProfileId: string): Promise<unknown> {
  return get(`${baseUrl}user/${userProfileId}`);
}

export function addPermissionUser(
  permissionKeys: string[],
  userProfileId: string
): Promise<unknown> {
  return postArray(`${baseUrl}user/${userProfileId}`, permissionKeys);
}

export function deletePermissionUser(
  permissionKeys: string[],
  userProfileId: string
): Promise<unknown> {
  return deleteArray(`${baseUrl}user/${userProfileId}`, permissionKeys);
}
